import { baseQuery } from '../../baseQuery/baseQuery';
import { createApi } from '@reduxjs/toolkit/query/react';
import { z } from 'zod';

const AddressSchema = z.object({
  street: z.string().nullish(),
  city: z.string().nullish(),
  country: z.string().nullish(),
  zip: z.string().nullish(),
});

export const CompanySchema = z.object({
  id: z.number(),
  clientAccountId: z.number(),
  name: z.string().nullish(),
  number: z.string().nullish(),
  connectId: z.string().nullish(),
  type: z.string().nullish(),
  userRole: z.string(),
  bankAccountNumber: z.string().nullish(),
});

export const UserSchema = z.object({
  id: z.number(),
  qcode: z.string(),
  email: z.string().optional(),
  phone: z.string().optional(),
  firstName: z.string().optional(),
  secondName: z.string().optional(),
  lastName: z.string().optional(),
  fullName: z.string().optional(),
  dateOfBirth: z.string().optional(),
  userInitials: z.string().optional(),
  personalNumber: z.string().optional(),
  address: AddressSchema.optional(),
});

export const UserInfoAndAccountsSchema = z.object({
  user: UserSchema,
  companies: z.array(CompanySchema),
  market: z.string(),
});

export type UserInfoAndAccountsResponse = z.infer<
  typeof UserInfoAndAccountsSchema
>;
export type UserInfo = z.infer<typeof UserSchema>;
export type CompanyInfo = z.infer<typeof CompanySchema>;

export const userManagementApi = createApi({
  reducerPath: 'userManagementApi',
  baseQuery: baseQuery(
    import.meta.env.VITE_API_SVC_USER_MANAGEMENT_EXTERNAL_BASE_URL,
    true
  ),
  endpoints: (build) => ({
    getUserInfoAndCompanies: build.query<UserInfoAndAccountsResponse, void>({
      query: () => ({
        url: '/user/accounts',
      }),
    }),
  }),
});

export const { useGetUserInfoAndCompaniesQuery } = userManagementApi;
